import api from './api';

/**
 * Sampling Boost правила и эффективный интервал камеры (ТЗ №39).
 * baseURL axios-инстанса уже равен /api.
 */

const BOOST_NOT_FOUND = 'sampling_boost_config_not_found';

const isBoostNotConfigured = (error) => {
  if (error?.response?.status !== 404) return false;
  const detail = error.response.data?.detail;
  const code = typeof detail === 'string' ? detail : detail?.code;
  return code === BOOST_NOT_FOUND;
};

const boostUrl = (ruleId) => `/admin/violation-rules/${ruleId}/sampling-boost`;

/** Конфигурация или null, если ускорение для правила не настроено. */
export const getSamplingBoost = (ruleId) =>
  api
    .get(boostUrl(ruleId))
    .then((response) => response.data)
    .catch((error) => {
      if (isBoostNotConfigured(error)) return null;
      throw error;
    });

export const putSamplingBoost = (ruleId, body) =>
  api.put(boostUrl(ruleId), body).then((response) => response.data);

export const deleteSamplingBoost = (ruleId) =>
  api.delete(boostUrl(ruleId)).then((response) => response.data);

export const getSamplingEffective = (cameraId) =>
  api.get(`/admin/cameras/${cameraId}/sampling-effective`).then((response) => response.data);
